import { GenIcon } from '../helpers/IconBase.es.js';

const UsaColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M24 4C24 3.4475 23.5525 3 23 3H10V13H0V20C0 20.5525 0.4475 21 1 21H23C23.5525 21 24 20.5525 24 20V4Z",
          fill: "#F83142"
        }
      },
      { tag: "path", attr: { d: "M24 5H10V7H24V5Z", fill: "white" } },
      { tag: "path", attr: { d: "M24 9H10V11H24V9Z", fill: "white" } },
      { tag: "path", attr: { d: "M0 13V15H24V13H10H0Z", fill: "white" } },
      { tag: "path", attr: { d: "M24 17H0V19H24V17Z", fill: "white" } },
      {
        tag: "path",
        attr: { d: "M10 13H0V4C0 3.4475 0.4475 3 1 3H10V13Z", fill: "#1435C3" }
      },
      {
        tag: "path",
        attr: {
          d: "M5.00008 6.96094L4.68358 7.64494H3.93158L4.48158 8.21494L4.27858 9.03894L5.00008 8.62994L5.72158 9.03894L5.51858 8.21494L6.06858 7.64494H5.31558L5.00008 6.96094Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.55341 4.5144L2.23741 5.1984H1.48541L2.03491 5.7684L1.83191 6.5924L2.55341 6.1834L3.27541 6.5924L3.07191 5.7684L3.62191 5.1984H2.86891L2.55341 4.5144Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.44655 4.5144L7.76255 5.1984H8.51455L7.96505 5.7684L8.16805 6.5924L7.44655 6.1834L6.72455 6.5924L6.92805 5.7684L6.37805 5.1984H7.13105L7.44655 4.5144Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.55341 11.4855L2.23741 10.8015H1.48541L2.03491 10.2315L1.83191 9.40747L2.55341 9.81647L3.27541 9.40747L3.07191 10.2315L3.62191 10.8015H2.86891L2.55341 11.4855Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.44655 11.4855L7.76255 10.8015H8.51455L7.96505 10.2315L8.16805 9.40747L7.44655 9.81647L6.72455 9.40747L6.92805 10.2315L6.37805 10.8015H7.13105L7.44655 11.4855Z",
          fill: "white"
        }
      }
    ]
  })(props);
};

export { UsaColored };
